module.exports = __webpack_public_path__ + "static/img/istatistik.95bc12c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/istatistik.jpg
// module id = mWhA
// module chunks = 1